module.exports = __webpack_public_path__ + "notFoundData.svg?229a0b343069282e5be03fe248b5a061";


//////////////////
// WEBPACK FOOTER
// ./src/assets/notFoundData.svg
// module id = 1121
// module chunks = 2